import APILibrary, { ClassExtender, GConstructor, GenerateResource } from './APILibrary';
import { AccountResource } from 'util/resources/Account';
import { Base } from 'active-resource';

/**
 * Relationship classes
 */
export class EmployerBlockingCalendarAttributes {
  accountId: string = null;
  calendarName: string = null;
  calendarId: string = null;
  enabled: boolean = null;
  id: string = null;
  service: string = null;
}

export class EmployerBlockingCalendarBelongsTo {
  account: () => AccountResource = () => new AccountResource();
}

export class EmployerBlockingCalendarHasOne {}
export class EmployerBlockingCalendarHasMany {}

/**
 * Utility interfaces
 */
export interface EmployerBlockingCalendarMethods {}

export interface EmployerBlockingCalendarInterface
  extends EmployerBlockingCalendarAttributes,
    EmployerBlockingCalendarBelongsTo,
    EmployerBlockingCalendarHasOne,
    EmployerBlockingCalendarHasMany,
    EmployerBlockingCalendarType {}

type EmployerBlockingCalendarType = GConstructor<EmployerBlockingCalendarInterface>;

export interface EmployerBlockingCalendarResource
  extends Base<EmployerBlockingCalendarAttributes>,
    EmployerBlockingCalendarInterface,
    EmployerBlockingCalendarMethods {}

/**
 * Resource methods
 */
const BaseClass = () =>
  GenerateResource<EmployerBlockingCalendarAttributes>({
    queryName: 'employers/blocking_calendars',
    className: 'BlockingCalendar',
    AttributesClass: EmployerBlockingCalendarAttributes,
    BelongsToClasses: [
      {
        Klass: EmployerBlockingCalendarBelongsTo,
      },
    ],
    HasOneClasses: [
      {
        Klass: EmployerBlockingCalendarHasOne,
      },
    ],
    HasManyClasses: [
      {
        Klass: EmployerBlockingCalendarHasMany,
      },
    ],
  });

export const EmployerBlockingCalendarResourceClass = <TBase extends EmployerBlockingCalendarType>(
  BaseConstructor: TBase,
): TBase => class extends BaseConstructor implements EmployerBlockingCalendarMethods {};

export class EmployerBlockingCalendarResource extends ClassExtender<EmployerBlockingCalendarInterface>(
  BaseClass,
  EmployerBlockingCalendarResourceClass,
) {}

/**
 * Resource instance
 */
export const EmployerBlockingCalendar = APILibrary.createResource<EmployerBlockingCalendarResource>(
  EmployerBlockingCalendarResource,
);
